import React from "react";
import { Dropdown } from "react-bootstrap";
import { Anchor, Box, Button, Heading, Icon, Item, List, Text } from "../elements";
import { CardHeader } from "../cards";
import { get_date } from "../generalComponets";
import { getSeverityBorder } from "../../features/notifications/notification.utils";

export function NotificationDropdown({
  title,
  icon,
  unreadCount,
  notifications = [],
  onItemClick,
  onMarkAllAsRead,
  onViewAll,
  loading,
  button,
  showEnableButton,
  onEnable,
  showBlockedMessage,
}) {
  const hasUnread = unreadCount > 0;

  return (
    <Dropdown>
      <Dropdown.Toggle className="mc-dropdown-toggle mc-header-icon ">
        <Icon type={icon} />
        {unreadCount > 0 && (
          <Text as="sup" className="primary">
            {unreadCount > 99 ? "99+" : unreadCount}
          </Text>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="mc-dropdown-paper">
        <Box className="mc-header-dropdown-group">
          <CardHeader title={`${title} (${unreadCount})`}>
            {hasUnread && (
              <Button text="Mark all as read" className="mc-notify-action-btn" onClick={onMarkAllAsRead} disabled={loading} />
            )}
          </CardHeader>
          <List className="mc-header-dropdown-list thin-scrolling">
            {notifications.length === 0 && (
              <Item className="mc-header-dropdown-item">
                <Box className="mc-header-dropdown-meta">
                  <Heading as="h4">
                    <Text as="cite">No notifications</Text>
                  </Heading>
                  <Text as="p">You're all caught up.</Text>
                </Box>
              </Item>
            )}
            {notifications.map((item) => (
              <Item key={item.id} className={`mc-header-dropdown-item ${!item.isRead ? "active" : ""}`}>
                <Anchor
                  className="mc-header-dropdown-content"
                  style={{ borderLeftColor: getSeverityBorder(item.severity) }}
                  onClick={() => onItemClick?.(item)}
                >
                  <Box className="mc-header-dropdown-meta">
                    <Heading as="h4">
                      <Text as="cite">{item?.title}</Text>
                    </Heading>
                    <Heading as="h4">
                      <span dangerouslySetInnerHTML={{ __html: item?.body }} />
                    </Heading>
                    <Text as="p">{get_date(item?.createdAt || item?.created_at)}</Text>
                  </Box>
                </Anchor>
              </Item>
            ))}
          </List>
          {onViewAll && (
            <Box className="mc-header-dropdown-button" style={{ cursor: "pointer", textAlign: "center" }} onClick={onViewAll}>
              View all notifications
            </Box>
          )}
          {showEnableButton && onEnable && (
            <Box
              className="mc-header-dropdown-button"
              style={{ cursor: "pointer", textAlign: "center", color: "#674BF5", fontWeight: 600 }}
              onClick={onEnable}
            >
              Enable Notifications
            </Box>
          )}
          {showBlockedMessage && (
            <Box
              className="mc-header-dropdown-button"
              style={{ textAlign: "center", color: "#9ca3af", fontSize: 12, padding: "8px 16px" }}
            >
              Notifications blocked. Enable them in your browser settings.
            </Box>
          )}
          {button?.path && button?.label && (
            <Anchor href={button.path} className="mc-btn primary mc-header-dropdown-button">
              {button.label}
            </Anchor>
          )}
        </Box>
      </Dropdown.Menu>
    </Dropdown>
  );
}
